var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.sidePanelDataObj.headerDataObj)?_c('panelheader',{attrs:{"header-data-obj":_vm.sidePanelDataObj.headerDataObj}}):_vm._e(),(_vm.sidePanelDataObj.iFrame)?_c('tabs',{attrs:{"tab-data-obj":_vm.sidePanelDataObj.tabSectionDataObj,"iFrame":_vm.sidePanelDataObj.iFrame}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }